import { endOfDay, format } from 'date-fns';

/**
 *
 * @param time Tiempo expresado en string
 * @returns Reemplaza guiones - por slash /
 */
const withSlash = (time: string) => (time ? time.replace(/-/g, '/') : '');
/**
 *
 * @param time Tiempo expresado en string
 * @returns Tiempo en String formateado de YYYY-MM-DD a DD/MM/YYYY
 */
const dateToString = (time: string) => {
  const timeFormatter = time
    ? `${new Date(withSlash(time)).toLocaleDateString('es-CL', {
        hour12: false,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      })}`
    : '';
  return timeFormatter.replace(/-/g, '/');
};

/**
 * Metodo que se encarga de validar si un dato existe.
 * @param dato valor del dato a validar.
 * @returns true si es valido, false si es invalido.
 */
export const esDatoValido = (dato: any) => dato && dato !== undefined && dato !== null;

/**
 * Recibe una fecha de tipo string y la transforma en el formato dd/MM/yyyy
 * @param dato fecha enviada
 * @returns fecha formateada
 */
export const formatoFecha = (dato: string) => {
  if (dato.length === 10) {
    return dateToString(dato);
  }
  return format(endOfDay(new Date(dato)), 'dd/MM/yyyy');
};
